import { FC, memo } from 'react';
import { useBilling } from '@hooks/common/useBilling';
import { usePricingContext } from '@pages/Pricing/context';
import PlanCard from '@pages/Settings/components/BillingTab/PlanCard';
import styled from 'styled-components';

import { CircularProgress } from '@mui/material';

const BillingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sk-space-6);
`;

const PlansContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sk-space-4);
`;

const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sk-space-12);
  color: var(--sk-cyan-500);
`;

const BillingTab: FC = () => {
  const { period } = usePricingContext();
  const { config, isLoadingQueries } = useBilling(period);

  if (isLoadingQueries) {
    return (
      <LoadingWrapper>
        <CircularProgress color="inherit" />
      </LoadingWrapper>
    );
  }

  return (
    <BillingContainer>
      <PlansContainer>
        {config.map((card: any) => (
          <PlanCard key={card.id} {...card} />
        ))}
      </PlansContainer>
    </BillingContainer>
  );
};

export default memo(BillingTab);
